import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppWithRouter from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { initAnalytics } from "./utilities/analyticsService";

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
		<AppWithRouter />
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
